
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Dictionary } from '../../utils';

@Component
export default class WindowEventBinder extends Vue {

  @Prop()
  private events: Dictionary<string>;

  created() {
    Object.keys(this.events).forEach((jsEvent: string) => {
      window.addEventListener(jsEvent, this.emitEvent, { passive: true });
    });
  }

  beforeDestroy() {
    Object.keys(this.events).forEach((jsEvent: string) => {
      window.removeEventListener(jsEvent, this.emitEvent);
    });
  }

  emitEvent(event: Event) {
    this.$x.emit(this.events[event.type], event);
  }

  render() {}
}
